import React, { useState } from "react";
import client from "../api/client";
import toast from "react-hot-toast";
import ButtonLoader from "../Components/ButtonLoader";

// Rendered as a second step inside Login.js (not a separate route) when
// signin responds with requiresTenantSelection: true, so refresh/back
// navigation mid-picker doesn't strand the user outside the login page.
const TenantSelector = ({ availableTenants, tempToken, onSelected }) => {
  const [selectingId, setSelectingId] = useState(null);

  const handleSelect = async (tenant) => {
    setSelectingId(tenant.id);
    try {
      const res = await client.post("/auth/select-tenant", {
        tempToken,
        tenantId: tenant.id,
      });
      onSelected(res.data);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to select tenant.");
    } finally {
      setSelectingId(null);
    }
  };

  return (
    <div className="flex flex-col gap-3 w-full">
      <p className="text-[11.25px] text-canvas-secondery text-center">
        Choose which account to sign in to
      </p>
      {availableTenants.map((tenant) => (
        <button
          key={tenant.id}
          type="button"
          disabled={selectingId !== null}
          onClick={() => handleSelect(tenant)}
          className="w-full flex items-center gap-3 justify-center text-center font-outfit text-[12px] uppercase font-bold bg-canvas-primary text-canvas-white py-3 px-5 rounded-[37px] disabled:cursor-not-allowed disabled:bg-canvas-primary/20 disabled:text-canvas-primary"
        >
          {selectingId === tenant.id && <ButtonLoader />}
          {tenant.name}
        </button>
      ))}
    </div>
  );
};

export default TenantSelector;
